// extracted by mini-css-extract-plugin
module.exports = {"DashboardCreateContainer":"NfnlNZ1K","loader":"_2SD41GQ1"};